import { graphqlAjax } from '..'
import { gql } from 'apollo-boost'
import { buildVariablesWithAliases } from '@G/api/utils'

const allOrdersSQL = () => {
  return `
data {
  id
  status
  department {
    id
    name
  }
  division {
    id
    name
  }
  section {
    id
    name
  }
  channel {
    id
    name
  }
  customer_service_id
  customer_service_name
  order_checker_id
  address
  target_address
  plan_coin
  plan_amount
  plan_exchange_rate
  receivable_coins
  receivable_exchange_rate
  receivable_amount
  description
  created_at
  updated_at
  completed_at
  op_link
  stage
  cancel_msg
  is_delayed
  delayed_at
  exchange_type
}
meta {
  total
}
`
}

export default {
  /* Query */
  getAllOrders: params => {
    const query = gql`
      query($filter: OrdersFilterInput) {
        allOrders(filter: $filter) {
          ${allOrdersSQL()}
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  getAllTabOrders: params => {
    const allStatus = Object.keys(params)
    const queryReducer = (acc, val, curr) => {
      return curr === 0
        ? `$filter_${val}: OrdersFilterInput`
        : `${acc}, $filter_${val}: OrdersFilterInput`
    }
    const resReducer = (acc, val) => {
      return `
        ${acc}
        ${val}: allOrders(filter: $filter_${val}) {
          ${allOrdersSQL()}
        }
      `
    }

    const query = gql`
      query(${allStatus.reduce(queryReducer, '')}) {
        ${allStatus.reduce(resReducer, '')}
      }
    `

    const variables = {
      ...buildVariablesWithAliases(params)
    }

    return graphqlAjax('get', query, variables)
  },
  getExchange: params => {
    const query = gql`
      query($_: Boolean) {
        getExchange(_: $_) {
          date
          hour
          platform
          currency
          fait_unit
          exchange
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  /**
   * 同時查分組跟組別，用於判斷新增訂單的權限
   */
  getDepartmentsAndDivisions: () => {
    const query = gql`
      query(
        $departmentIn: DepartmentsFilterInput!
        $divisioinIn: DivisionsFilterInput!
      ) {
        allDepartments(in: $departmentIn) {
          meta {
            total
          }
        }
        allDivisions(in: $divisioinIn) {
          meta {
            total
          }
        }
      }
    `
    return graphqlAjax('get', query, {
      departmentIn: {},
      divisioinIn: {}
    })
  },
  /* Mutation */
  updateOrder: (params, opts = {}) => {
    const mutation = gql`
      mutation($id: Int!, $in: UpdateOrderInput!) {
        updateOrder(id: $id, in: $in) {
          id
        }
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  },
  createOrder: (params, opts = {}) => {
    const mutation = gql`
      mutation($in: CreateOrderInput!) {
        createOrder(in: $in) {
          id
        }
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  },
  uploadOrder: params => {
    const mutation = gql`
      mutation($in: [UploadOrderInput!]!) {
        uploadOrder(in: $in)
      }
    `
    return graphqlAjax('post', mutation, params)
  }
}
